import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/twine`;

interface Props {
    className?: string;
}

export const TwineInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            筈巻加工の選び方
        </Title>
        <Image src={`${IMG_PATH}/twine.png`} />

        <SubTitle>筈巻(はずまき)加工について</SubTitle>
        <Paragraph>
            ペインティングラインは毛引きと同じ技法で職人が1本1本手で描きます。
            きれいな発色で、毛引きと同じ数の色からお選びいただけます。
        </Paragraph>

        <Paragraph>
            織込み・糸ラインは糸巻部分の糸を途中から2本でより合わせて模様を付けた加工の事を言います。
        </Paragraph>

        <Paragraph>
            ※「和紙」をお選びの場合、ペインティングラインはお選びいただけますが、
            織込みと糸ラインはお選びいただけません。
        </Paragraph>

        <Paragraph>
            ※先にお選びいただいた糸の色に対して、
            ここでお選びいただく糸やペインティングの色が同系色の場合、
            模様が綺麗に出にくい可能性がございます。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpTwine: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <TwineInner />
            </div>
        </div>
    </Panel>
);
